import { UnknownError } from '@cian/peperrors';

import { showAlert } from '../../../slices/alertSlice';
import { TThunkAction } from '../../../types/redux/thunk';
import { ETelemetryEvents } from '../../../types/telemetry';
import { setFirstMessageFailed } from '../actions';
import { DEFAULT_ERROR_MESSAGE } from '../constants';
import { EFirstMessageResponseStatus, IAssertDependencies, TFirstMessageResponse } from '../types';

export const assertUnknownErrorStatus =
  (response: TFirstMessageResponse, { domain, telemetry }: IAssertDependencies): TThunkAction<void> =>
  (dispatch, _getState, { logger }) => {
    if (response.status === EFirstMessageResponseStatus.UnknownError) {
      telemetry.increment(ETelemetryEvents.ChatFirstMessageSendUnknownError);

      dispatch(setFirstMessageFailed());
      // В message 400-ответа приходит машинный код ошибки, пользователю показываем общий текст
      dispatch(showAlert({ message: DEFAULT_ERROR_MESSAGE }));

      const unknownError = new UnknownError({
        message: response.data.message || DEFAULT_ERROR_MESSAGE,
        domain,
      });

      logger.error(unknownError);
    }
  };
